import React from 'react'
import PropTypes from 'prop-types'
import { formatTimestamp } from '../../utilities/messageHelpers'
import { Check, CheckCheck } from 'lucide-react'

function MessageBubble({ message, isOwn }) {
  const body = message?.attributes?.body || message?.body || ''
  const createdAt = message?.attributes?.createdAt || message?.createdAt
  const readAt = message?.attributes?.readAt || message?.readAt
  const isUnread = !isOwn && !readAt

  const bubbleClasses = isOwn
    ? 'bg-purple-100 text-purple-900 ml-auto'
    : isUnread
    ? 'bg-purple-50 text-gray-900 mr-auto ring-2 ring-purple-200'
    : 'bg-gray-100 text-gray-900 mr-auto'

  return (
    <div className={`max-w-[70%] ${isOwn ? 'ml-auto' : 'mr-auto'} mb-2`}>
      <div className={`rounded-lg px-4 py-2 ${bubbleClasses}`}>
        <p className={`text-sm whitespace-pre-wrap break-words ${isUnread ? 'font-medium' : ''}`}>{body}</p>
      </div>
      <div className={`flex items-center gap-1 mt-1 px-1 ${isOwn ? 'justify-end' : 'justify-start'}`}>
        <span className="text-xs text-gray-500">{formatTimestamp(createdAt)}</span>
        {isOwn && (
          <span className="text-gray-500">
            {readAt ? <CheckCheck className="w-3 h-3" /> : <Check className="w-3 h-3" />}
          </span>
        )}
      </div>
    </div>
  )
}

MessageBubble.propTypes = {
  message: PropTypes.object.isRequired,
  isOwn: PropTypes.bool.isRequired
}

export default MessageBubble
